import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const PageNews = lazy(() => import('@cobliteam/news'));

const routes = [
  {
    title: locationName[Location.NEWS],
    path: Location.NEWS,
    component: PageNews,
  },
];

export default routes;
